import { AxiosService } from 'src/services/AxiosService';

export class TrucodeReferencesService extends AxiosService {

  public async getBookReference(option?: string): Promise<TitledObject[] | undefined> {
      const result =  await this.axiosCall<TitledObject[]>({
        method: 'get',
        url: `/grouper/${encodeURIComponent(this.facilityCode)}/reference/book?option=${encodeURIComponent(option || '')}`,
      });

      if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getBookReferenceYears(bookId: string): Promise<number[] | undefined> {
    const result =  await this.axiosCall<number[]>({
      method: 'get',
      url: `/grouper/${encodeURIComponent(this.facilityCode)}/reference/book/${encodeURIComponent(bookId)}/year/`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getBookReferenceYearIssue(book: string, year: number): Promise<TitledObject[] | undefined> {
    const result =  await this.axiosCall<TitledObject[]>({
      method: 'get',
      url: `/grouper/${encodeURIComponent(this.facilityCode)}/reference/book/${encodeURIComponent(book)}/year/${encodeURIComponent(year)}/issue`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getReferencesArticle(articleId: string): Promise<string | undefined> {
    const result =  await this.axiosCall<string>({
      method: 'get',
      url: `/grouper/${encodeURIComponent(this.facilityCode)}/reference/article/${encodeURIComponent(articleId)}?partial=true`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getReferencesArticles(issueId: number): Promise<TitledObject[] | undefined> {
    const result =  await this.axiosCall<GetReferencesArticlesResponse>({
      method: 'get',
      url: `/grouper/reference/issue/${encodeURIComponent(issueId)}/article/${encodeURIComponent(this.facilityCode)}`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result?.data?.Articles.map(article => {
      return {id: article.ID, title: article.ArticleTitle};
    }) || [];
  }

  public async getReferenceBookTermSearch(book: string, term: string): Promise<TitledObject[]> {
    const result =  await this.axiosCall<GetReferenceBookTermSearchResponse[]>({
      method: 'get',
      url: `/grouper/${encodeURIComponent(this.facilityCode)}/reference/book/${encodeURIComponent(book)}/${encodeURIComponent(term)}`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    const mappedResults: TitledObject[] = [];
    (result?.data || []).map(searchGroup => {
      (searchGroup?.articles || []).forEach((article) => {
        mappedResults.push({
          id: article.article_id,
          title: article.article_title,
          best: searchGroup?.name == 'Best'
        });
      });
    });

    return mappedResults;
  }
}

export type TitledObject = {
  id: string,
  title: string
  type?: 'book'|'year'|'issue'|'article'
  lazy?: boolean;
  selectable?: boolean;
  best?: boolean;
  expanded?: boolean;
}

export interface GetReferencesArticlesResponse {
  Articles: {ID: string, ArticleTitle: string}[]
}

export interface GetReferenceBookTermSearchResponse {
  name: string,
  articles: GetArticleResponse[]
}

export interface GetArticleResponse {
  details: ArtifactDetails,
  article_id: string,
  article_title: string
}

export interface ArtifactDetails {
  issueTitle: string,
  issueYear: string,
  issueMonth: string
}
